import type { FC } from 'react';
import type { IBaseContentTile } from '@/services/isomorphic/ContentService';
import { classes } from '@/next-utils/css-utils/scss-utils';
import { NavigationTile } from '../NavigationTile';

import S from './styles.base.module.scss';

interface INavigationTileProps {
  /**
   * The list of tiles to render.
   */
  tiles: Array<IBaseContentTile>;
  /**
   * Optional callback for handling when links are clicked.
   */
  handleLinkClick?: () => void;
}

/**
 * Navigation Tiles Component.
 */
export const NavigationTiles: FC<INavigationTileProps> = ({
  tiles,
  handleLinkClick
}) => {
  const firstThreeTiles = tiles.slice(0, 3);

  return (
    <div
      className={classes(
        S.tiles,
        firstThreeTiles.length === 2 && S.twoTile,
        firstThreeTiles.length === 3 && S.threeTile
      )}
    >
      {firstThreeTiles.map((tile) => {
        const firstLink = tile.links[0];

        return (
          <NavigationTile
            handleLinkClick={handleLinkClick}
            key={`content-item-${tile.headline}`}
            headline={tile.headline}
            mediaItems={tile.media}
            link={firstLink ?? null}
            linkStyleOverride={S.linkStyleOverride}
            textAlignmentX={tile.textAlignmentX}
            textAlignmentY={tile.textAlignmentY}
          />
        );
      })}
    </div>
  );
};
